// removed by extract-text-webpack-plugin
module.exports = {"BuildControls":"-name__-loca-__3_01f","OrderButton":"-name__-loca-__myBwT","enable":"-name__-loca-__3jYIq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BuildControls/BuildControls.css
// module id = 171
// module chunks = 0